export default {
    // Название формы для отправки ссылки
    postbackForm: {
        // Поля формы
        fields: {
            // Текст ошибки для поля postback
            postback: {
                422001: 'POSTBACK_UPDATE_URL_ERROR',
                default: 'POSTBACK_UPDATE_UNKNOWN_ERROR',
            },
            // Текст ошибки для поля postbackFormat
            postbackFormat: {
                422001: 'POSTBACK_UPDATE_UNKNOWN_ERROR',
                default: 'POSTBACK_UPDATE_UNKNOWN_ERROR',
            },
        },
        // Дефолтный текст формы
        default: 'POSTBACK_UPDATE_UNKNOWN_ERROR',
    },
};
